<template>
  <div>
    <RsPartialIFrameNavBar
      v-if="iframeNavConfig"
      :nav-config="iframeNavConfig"
    />
    <button
      v-else-if="(backButtonConfig && !$route.meta?.hideIframeBackButton) || $route.meta?.hasIframeBackButton"
      class="title-back-button m-3"
      :title="backButtonConfig?.title"
      @click="$router.back()"
    >
      <i class="fas fa-arrow-left" />
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import appMixin from '@/mixins/app-mixin';
import RsPartialIFrameNavBar from './RsPartialIFrameNavBar.vue';
import { IFrameNav } from '@/shared';

export default defineComponent({
  name: 'RsPartialIFrameAppHeader',

  components: {
    RsPartialIFrameNavBar,
  },

  mixins: [appMixin],

  computed: {
    iframeNavConfig(): IFrameNav | null {
      return this.$route.meta?.iframeNav ?? null;
    },
  },
});
</script>
